import { DropdownSingleSelect } from "components/DropdownSingleSelect";

import { TRANSIENT_INPUT_HEIGHT } from "../lib/transientForm";
import { ScenarioFieldRow } from "./ScenarioFieldRow";

type TransientDropdownFieldRowProps<T extends string> = {
  alignControlEnd?: boolean;
  displayOptions: string[];
  label: string;
  labelClassName?: string;
  onSelect: (value: T) => void;
  options: readonly T[];
  selectedValue: T;
};

export const TransientDropdownFieldRow = <T extends string>({
  alignControlEnd = false,
  displayOptions,
  label,
  labelClassName,
  onSelect,
  options,
  selectedValue,
}: TransientDropdownFieldRowProps<T>) => {
  return (
    <ScenarioFieldRow alignControlEnd={alignControlEnd} label={label} labelClassName={labelClassName}>
      <DropdownSingleSelect
        borderColor="var(--color-border-subtle)"
        className="w-full"
        clearable={false}
        displayOptions={displayOptions}
        height={TRANSIENT_INPUT_HEIGHT}
        hideLabel
        options={[...options]}
        selectedValue={selectedValue}
        setSelectedValue={(value) => {
          const option = options.find((item) => item === value);
          if (option) onSelect(option);
        }}
      />
    </ScenarioFieldRow>
  );
};
